/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     TrainingQuestionsPanel
//   Details:    TrainingQuestionsPanel component
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103782 10/12/19 JC       New
// 105066 06/01/20 JC  M01  Added font awesome
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//M01 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M01
import './css/Item.css';

class TrainingQuestionsPanel extends Component {
	constructor(props) {
		super(props);

        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleChangeAnswer = this.handleChangeAnswer.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
	}

    handlePrev = event => {
        event.preventDefault();
        const { item } = this.props;
        this.props.changeTrainingQuestion(item, false);
    }

    handleNext = event => {
        event.preventDefault();
        const { item} = this.props;
        this.props.changeTrainingQuestion(item, true);
    }

    handleChangeAnswer = event => {
        //get the new answer index
        var newAnswerIndex = Number(event.target.value);

        //pass to parent to update
        const { item } = this.props;
        this.props.answerTrainingQuestion(item, newAnswerIndex);
    }

    handleComplete = event => {
        event.preventDefault();
        const { item } = this.props;
        this.props.completeTraining(item);
    }

	render() {
        const { item } = this.props;

        //get the current question index & length
        var nCurrentQuestionIndex = item.currentQuestionIndex;
        var nQuestionsLength = item.questions.length;

        //get current question
        var currentQuestion = item.questions[nCurrentQuestionIndex];

        //get the currently selected answer
        var answer = item.employeeAnswers[nCurrentQuestionIndex];

        //get the current question text
        var currentQuestionText = `Question ${(nCurrentQuestionIndex + 1)} of ${nQuestionsLength}`;

        //determine if we can prev or next
        const canPrev = nCurrentQuestionIndex > 0; // not at the first question
        const canNext = ((nCurrentQuestionIndex + 1 < nQuestionsLength) && answer !== -1); //not at the last question, and an answer selected
        const canComplete = !canNext && !item.employeeAnswers.includes(-1); //not can next, and also does not contain an unanswered question

        return (
            <div>

                <div className="page-item-row">

                    <div className="text-col">

                        {/* print question position */}
                        <span style={{ fontWeight: "bold" }}>{currentQuestionText}<br /><br /></span>

                        {/* display the question */
                            currentQuestion.question.split('\n').map((i, k) => {
                                return <span>{i}<br /></span>;
                            })}

                    


                    {/* bottom tray, prev & next */}
                        <div className="button-group float-right">

                                {/* answer drop down */}
                                <select id="answer" onChange={this.handleChangeAnswer} value={answer}>
                                    <option value="-1">Select an answer...</option>
                                    {currentQuestion.answers.map((answer, answerIndex) => <option key={answerIndex} value={answerIndex}>{answer.answer}</option>)}
                                </select>


                                {/* buttons */}
                                <button className="btn btn-default" disabled={!canPrev} onClick={this.handlePrev}><FontAwesomeIcon icon="chevron-left" /> Previous</button> {/* M01 */}
                                <button className="btn btn-default" disabled={!canNext} onClick={this.handleNext}>Next <FontAwesomeIcon icon="chevron-right" /></button> {/* M01 */}
                                <button className="btn btn-default" disabled={!canComplete} onClick={this.handleComplete}>Complete <FontAwesomeIcon icon="save" /></button> {/* M01 */}
                            </div>
                    </div>
                </div >
			</div >
		);
	}
}

TrainingQuestionsPanel.propTypes = {
    item: PropTypes.object.isRequired,
    changeTrainingQuestion: PropTypes.func.isRequired,
    answerTrainingQuestion: PropTypes.func.isRequired,
    completeTraining: PropTypes.func.isRequired
};


export default connect(
	state => state
)(TrainingQuestionsPanel);
